<template>
 <div class="modal center fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2" @click.self="closeCart" style="z-index:9999999">
  <div class="modal-dialog" role="document">
   <div class="modal-content flex-column cart"> 
    <div class="cartTop">
     <div class="modal-body flex-column fill">
      <div class="cartHeaderSection">
       <div class="cartHeader">Your Cart</div>
       <div class="cartClose">
        <button type="button" class="close" aria-label="Close" @click="closeCart"><span aria-hidden="true"><small>Close</small> &times;</span></button>
       </div>
      </div>
      <div class="cartProductSection">
       <div v-if="items.length" class="item-cart">
	<landing-cart-item v-for="product in visibleProducts" v-if="product.id == primaryProduct"
	 :currency-symbol-right="currencySymbolRight" 
         :currency-symbol-left="currencySymbolLeft" 
	 :key="product.id + '_' + product.quantity + '_' + product.free"
	 :product="product"
         :membership="membership"
	 @changeProduct="changeProduct"
         @subscribe="subscribe"
 	 >
        </landing-cart-item>
        <landing-cart-item v-for="product in visibleProducts" v-if="product.id != primaryProduct && product.id!= 1"
         :currency-symbol-right="currencySymbolRight"
         :currency-symbol-left="currencySymbolLeft"
         :key="product.id + '_' + product.quantity + '_' + product.free"
         :product="product"
         :membership="membership"
         @changeProduct="changeProduct"
         @subscribe="subscribe"
         >
        </landing-cart-item>
        <landing-cart-item v-for="product in visibleProducts" v-if="product.id== 1"
         :currency-symbol-right="currencySymbolRight"
         :currency-symbol-left="currencySymbolLeft"
         :key="product.id + '_' + product.quantity + '_' + product.free"
         :product="product"
         :membership="membership"
         @changeProduct="changeProduct"
         >
        </landing-cart-item>
       </div>
       <shopping-cart-notification v-for="(notification, index) in notifications" :key="index"
	:notification="notification">
       </shopping-cart-notification>
      </div>
     </div>
     <!-- modal-body -->
    </div>
    <!-- cart top -->
     <div class="modal-body flex-column fill">
      <div class="suggested-product-section">
       <h2>The Ideal Stack to Tackle All Your Deficiencies</h2>
       <div class="suggested-product-container">
        <div v-for="pid in suggestedProductsArray" class="suggested-product-box">
         <div class="suggested-product-image">
           <img :src="productData[pid].image">
         </div>
         <div class="suggested-product-info">
           <h2>{{ productData[pid].name }}</h2>
           <div class="suggested-product-blurb">{{ suggestedBlurbs[pid] }}</div>
           <div class="suggested-product-price">
            <span v-if="autoship == true" :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ productData[pid].autoPrice }}</span>
            <span v-else-if="membership ==1" :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ productData[pid].price }}</span>
            <span v-else :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ productData[pid].retailPrice }}</span>


            <span v-if="membership == 1"  :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft" class="suggested-product-price-strike">{{ productData[pid].retailPrice }}</span>
           </div>
           <div v-if="membership == 1" class="suggested-product-price-with-membership">with your membership</div>
           <div class="suggested-product-add">
            <a v-if="productsObject[pid]" class="suggestedAdd">
             Added to Cart
            </a>
            <a v-else class="suggestedAdd click" @click="addSuggestedToCart(pid)">
             Add to Cart
            </a>
           </div>
         </div>
        </div> 
       </div>
      </div>
     </div>

     <div class="modal-body flex-column fill" v-if="membership!=1">
      <div class="cart-membership-section">
        <div class="cart-membership-top">
           Save {{ membershipSavePercent }}% on this & every other order
        </div>
        <div class="cart-membership-body">
           Become a LiveGood member for only 
           <b><span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ productData[1].price }}</span>
           per month and save 20%</b> on all your orders... and you can cancel anytime. For your order today:
           <div class="cart-membership-prices">
             <div class="cart-membership-prices-retail">
              Retail  Price<br>
              <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ retailTotalPrice }}</span>
             </div>
             <div class="cart-membership-prices-membership">
              Membership<br>
              <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ totalPrice }}</span>
             </div>
           </div>
           <button @click="addSuggestedToCart(1)">
            Become a Member & Save 
              <b><span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ totalMemberSave }}</span></b>
            Now 
           </button>
        </div>
      </div>
     </div>

     <div class="modal-body flex-column fill">
      <landing-cart-summary v-if="products.length > 0"
       :currency-symbol-right="currencySymbolRight" 
       :currency-symbol-left="currencySymbolLeft"
       :minus-currency-symbol-left="minusCurrencySymbolLeft"
       :productCount="productCount"
       :productFreeCount="productFreeCount"
       :totalPrice="totalPrice"
       :retailTotalPrice="retailTotalPrice"
       :autoTotalPrice="autoTotalPrice"
       :percentOffName="percentOffName"
       :percentSavings="percentSavings"
       :percentRetailSavings="percentRetailSavings" 
       :percentOffNameSecond="percentOffNameSecond"
       :percentSavingsSecond="percentSavingsSecond"
       :isLoggedIn="isLoggedIn"
       :totalMemberSave="totalMemberSave"
       :totalAutoSave="totalAutoSave"
       :membership="membership"
       :scriptName="scriptName"
       :couponAmount="couponAmount"
       :enrollerFirst="enrollerFirst"
       :shippingOrderCount="shippingOrderCount"
       :retailOnly="retailOnly"
       :autoship="autoship"
       @changeProduct="changeProduct"
       >
      </landing-cart-summary>
      <div class="item-butn">
       <ul>
	<li ><a onclick="cartCheckout()" data-dismiss="modal" data-toggle="modal" data-target="#myModal" href="#">Continue to Checkout</a></li>
       </ul>
      </div>
     </div>
    </div>
    <!-- modal-body -->               
  </div>
  <!-- modal-content -->
 </div>
</template>

<script lang="ts">
    import LandingCartItem from './LandingCartItem.vue';
	import ShoppingCartNotification from './ShoppingCartNotification.vue'; 
	import LandingCartSummary from './LandingCartSummary.vue';
	import { currencySymbols, euHempCountries } from '../currencySymbols.pl'
	import { countries } from '../countries.pl'

    export default {
        props: {
	 productDataJson: String,
	 hasEnroller: Boolean,
	 isLoggedIn: Boolean,
	 isPreenrollee: Boolean,
         scriptName: String,
         openCartInitially: Boolean,
         coupon: Number,
         enrollerFirst: String,
         retailOnly:Number,
         primaryProduct:Number,
         suggestedProductsArrayString: String,
         suggestedProductsBlurbJson: String,
            /* products: Array */
        },
        components: {
                'landing-cart-item': LandingCartItem,
		'shopping-cart-notification': ShoppingCartNotification,
	        'landing-cart-summary': LandingCartSummary,
		},
		watch: {
			countryCode: function(newCountry,oldCountry) {
				if (newCountry && oldCountry) {
					this.countryChangeReload()	
				}
			},
			isOpen: function(isOpen) {
				if (isOpen) {
					jQuery("#myModal2").modal('show')
				} else {
					jQuery("#myModal2").modal('hide')
				}
			}
		},
		data: function () {
			return {
				isOpen: false,
				bvModalIsOpen: false,
				items: [],
				products: [],
				notifications: [],
				totalPrice: '0',
				retailTotalPrice: '0',
                                autoTotalPrice: '0',
				totalBV: 0,
				countryCode: '',
				percentSavings: 0,
                                percentRetailSavings: 0,
				percentOffName: '',
				percentSavingsSecond: 0,
				percentOffNameSecond: '',
				countries,
                                totalMemberSave: '0',
                                totalAutoSave: '0',
                                membership:0,
                                couponAmount:0,
                                shippingOrderCount:0
			}
		},
		methods: {
                   addSuggestedToCart (suggested) {
                      console.log('add suggested to cart ',suggested)
                      let autoship = 0
                      if (this.productsObject[this.primaryProduct].autoship) {
                         autoship = 1
                      }
                      console.log("suggested autoship - ", autoship, " primary ", this.productsObject[this.primaryProduct].autoship)
                      shoppingCart.addToCart(suggested,1,autoship).then((x) => {
                         this.getProducts()
                      })
                   },
			countryChangeReload: function() {
				shoppingCart.update({ country: this.countryCode }).then(function () {
					location.reload();
				});
			},
			isSpecialPackSubProduct(id) {
				return /\d+_\d+/.test(id)
			},
			mapItemsToProductMeta: function () {
				let vm = this;
				let products = [];
				let subProducts = []
				let freeCounts = new Map();
				this.items.forEach(function (item) {
					if (item.free) {
						let productId = item.productId.replace("FREE_", "");
                                                if (item.condition) {
                                                   productId = productId.replace("_" + item.condition, "");
                                                }
						freeCounts[productId] = item.quantity;
						item.productId = productId
					}
				});


				this.items.forEach((item) => {
					if (this.isSpecialPackSubProduct(item.productId)) {
						item = {
							...item, 
							isSpecialPackSubProduct: true,
							productId: String(item.productId).match(/\d+_(?<subpid>\d+)/).groups.subpid
						}
					}
					if (vm.productData[item.productId]) {
						let product = {
							'id': item.productId,
							'name': vm.productData[item.productId].name,
							'price': vm.productData[item.productId].price,
                                                        'retailPrice': vm.productData[item.productId].retailPrice,
                                                        'autoPrice': vm.productData[item.productId].autoPrice,
							'bv': vm.productData[item.productId].bv,
							'quantity': item.quantity,
							'free': item.free,
							'freeCount': freeCounts[item.productId],
							'image': vm.productData[item.productId].image,
							'max': parseInt(vm.productData[item.productId].max, 10),
							'product_months': vm.productData[item.productId].product_months,
							'monthly_bv': vm.productData[item.productId].monthly_bv,
							'sale': vm.productData[item.productId].sale,
				                        'saleMessage': vm.productData[item.productId].saleMessage,
							'salePrice': vm.productData[item.productId].salePrice,
							'isSpecialPackMainProduct': vm.productData[item.productId].isSpecialPackMainProduct,
							'isSpecialPackSubProduct': item.isSpecialPackSubProduct,
							'allowAutoship': (this.isLoggedIn && !this.isPreenrollee) && vm.productData[item.productId].allowAutoship,
							'autoship': item.autoship,
                                                        'condition_message': item.condition_message,
                                                        'condition': item.condition
						};

						if (vm.productData[item.productId].flavor) {
							product['flavor'] = vm.productData[item.productId].flavor;
						}

						if (vm.productData[item.productId].size) {
							product['size'] = vm.productData[item.productId].size;
						}
						if (vm.productData[item.productId].promoCartMessage) {
							product['promoCartMessage'] = vm.productData[item.productId].promoCartMessage;
						}
						if (vm.productData[item.productId].promoCartMessageLine2) {
							product['promoCartMessageLine2'] = vm.productData[item.productId].promoCartMessageLine2;
						}
						products.push(product);
					}
				});

				this.items	
					.map(p => String(p.productId).match(/(?<main>\d+)_(?<sub>\d+)/)?.groups)
					.filter(p => p)
					.map(m => ({
						...m, 
						sub: products.find(({id}) => id == m.sub)
					}))
					.forEach(({main, sub}) => {
						const p = products.find(({id}) => id == main)
						p.specialPackSubProducts = p.specialPackSubProducts
							? p.specialPackSubProducts.concat(sub)
							: [sub]
					})

				this.products = products;
			},
			closeCart: function (e) {
//				this.updateShoppingCartCount();
				this.isOpen = false;
			},
			getProducts: async function () {
				let vm = this;

				await shoppingCart.get().then(
					function (data) {
						vm.items = data.shoppingCartDetails || [];
						vm.mapItemsToProductMeta();
						vm.notifications = data.notifications || [];
						vm.totalPrice = Number(data.amount || 0).toFixed(2);
						vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
                                                vm.autoTotalPrice = Number(data.autoAmount || 0).toFixed(2);
						vm.totalBV = data.bv || 0;
						vm.countryCode = data.country;
						vm.percentSavings = Number(data.percentSavings).toFixed(2)
                                                vm.percentRetailSavings = Number(data.percentRetailSavings).toFixed(2)
						vm.percentOffName = data.percentOffName
						vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
						vm.percentOffNameSecond = data.percentOffNameSecond
                                                vm.couponAmount = Number(data.couponAmount || 0).toFixed(2)
                                                vm.shippingOrderCount =Number(data.shippingOrderCount ||0)
                                                if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                                                   vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                                                   vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);                             
                                                   vm.autoTotalPrice = Number(data.autoAmount - vm.couponAmoun || 0).toFixed(2);
                                                }
                                                vm.totalMemberSave = Number(data.totalMemberSave  || 0).toFixed(2);
                                                vm.totalAutoSave = Number(data.totalAutoSave  || 0).toFixed(2);
                                                vm.membership = data.membership || 0;
					}
				);
			},
			changeProduct({
				id: productID, 
				quantity, 
				autoship,
				isSpecialPackMainProduct, 
				specialPackSubProducts,
                                condition
			}) {
                                console.log("in change product")
				let vm = this;
                                shoppingCart.setProduct(productID, {quantity, autoship})
				.then(shoppingCart.get)
            			.then(data => {
					vm.items = data.shoppingCartDetails || [];
					vm.mapItemsToProductMeta();
					vm.notifications = data.notifications || [];
					vm.totalPrice = Number(data.amount || 0).toFixed(2);
					vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
                                        vm.autoTotalPrice = Number(data.autoAmount || 0).toFixed(2);
					vm.totalBV = data.bv || 0;
					vm.percentSavings = Number(data.percentSavings).toFixed(2)
                                        vm.percentRetailSavings = Number(data.percentRetailSavings).toFixed(2)
					vm.percentOffName = data.percentOffName
					vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
					vm.percentOffNameSecond = data.percentOffNameSecond
                                        vm.couponAmount = Number(data.couponAmount || 0).toFixed(2);
                                        vm.shippingOrderCount =  Number(data.shippingOrderCount || 0)
                                        if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                                           vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                                           vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);
                                           vm.autoTotalPrice = Number(data.autoAmount - vm.couponAmoun || 0).toFixed(2);
                                        }
                                        vm.totalMemberSave = Number(data.totalMemberSave || 0).toFixed(2);
                                        vm.totalAutoSave = Number(data.totalAutoSave  || 0).toFixed(2);
                                        vm.membership = data.membership || 0;
                                        vm.tax = Number(data.tax || 0).toFixed(2)
				})
				
			},
			openCountryPopup: function () {
				this.closeCart();
				document.getElementById("country-selector-popup").style.display = "flex";
			},
			openBVModal: function () {
				this.bvModalIsOpen = true;;
			},
			closeBVModal: function () {
				this.bvModalIsOpen = false;
			},
			updateShoppingCartCount: function () {
				var openCart = document.getElementById('openCart'),
					className = 'shopping-cart-item-count',
					itemCount = 0;

				itemCount = this.productCount 
                                console.log("updating product Counts",this.productCount)
				if (itemCount > 0) {
					if (openCart.getElementsByClassName(className).length == 0) {
						var cartCountSpan = document.createElement('span');
						cartCountSpan.className = className;
						cartCountSpan.textContent = itemCount;
						openCart.appendChild(cartCountSpan);
					} else {
						openCart.getElementsByClassName(className)[0].innerHTML = itemCount;
					}

				} else {
					if (openCart.getElementsByClassName(className).length > 0) {
						var cartCountSpan = openCart.getElementsByClassName(className)[0]
						
						cartCountSpan.parentNode.removeChild(cartCountSpan);
					}

				}
			},
                        subscribe: function () {
                           console.log("subscribe ran")
                           let vm = this;
                           this.visibleProducts.forEach(function (product) {
                             console.log("subscribe -- ",product.id)
                             if (product.quantity >=1 && !product.autoship && product.id !=1) {
                                shoppingCart.setProductAutoship(product.id, product.quantity, 1)
                                .then(shoppingCart.get)
                                .then(data => {
                                        vm.items = data.shoppingCartDetails || [];
                                        vm.mapItemsToProductMeta();
                                        vm.notifications = data.notifications || [];
                                        vm.totalPrice = Number(data.amount || 0).toFixed(2);
                                        vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
                                        vm.autoTotalPrice = Number(data.autoAmount || 0).toFixed(2);
                                        vm.totalBV = data.bv || 0;
                                        vm.percentSavings = Number(data.percentSavings).toFixed(2)
                                        vm.percentRetailSavings = Number(data.percentRetailSavings).toFixed(2)
                                        vm.percentOffName = data.percentOffName
                                        vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
                                        vm.percentOffNameSecond = data.percentOffNameSecond
                                        vm.couponAmount = Number(data.couponAmount || 0).toFixed(2);
                                        vm.shippingOrderCount =  Number(data.shippingOrderCount || 0)
                                        if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                                           vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                                           vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);
                                           vm.autoTotalPrice = Number(data.autoAmount - vm.couponAmount || 0).toFixed(2);
                                        }
                                        vm.totalMemberSave = Number(data.totalMemberSave || 0).toFixed(2);
                                        vm.totalAutoSave = Number(data.totalAutoSave  || 0).toFixed(2);
                                        vm.membership = data.membership || 0;
                                        vm.tax = Number(data.tax || 0).toFixed(2)
                                })
                              }
                           })
                           if (!this.membership) {
                              shoppingCart.setProductAutoship(1, 1, 0)
                              .then(shoppingCart.get)
                              .then(data => {
                                        vm.items = data.shoppingCartDetails || [];
                                        vm.mapItemsToProductMeta();
                                        vm.notifications = data.notifications || [];
                                        vm.totalPrice = Number(data.amount || 0).toFixed(2);
                                        vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
                                        vm.autoTotalPrice = Number(data.autoAmount || 0).toFixed(2);
                                        vm.totalBV = data.bv || 0;
                                        vm.percentSavings = Number(data.percentSavings).toFixed(2)
                                        vm.percentRetailSavings = Number(data.percentRetailSavings).toFixed(2)
                                        vm.percentOffName = data.percentOffName
                                        vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
                                        vm.percentOffNameSecond = data.percentOffNameSecond
                                        vm.couponAmount = Number(data.couponAmount || 0).toFixed(2);
                                        vm.shippingOrderCount =  Number(data.shippingOrderCount || 0)
                                        if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                                           vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                                           vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);
                                           vm.autoTotalPrice = Number(data.autoAmount - vm.couponAmount || 0).toFixed(2);
                                        }
                                        vm.totalMemberSave = Number(data.totalMemberSave || 0).toFixed(2);
                                        vm.totalAutoSave = Number(data.totalAutoSave  || 0).toFixed(2);
                                        vm.membership = data.membership || 0;
                                        vm.tax = Number(data.tax || 0).toFixed(2)
                              })
                              this.membership = 1
                           }
                        },
		},
		created: function () {

		},
        computed: {
            suggestedProductsArray: function () {
               return this.suggestedProductsArrayString.split(",");
            },
            membershipSavePercent() {
               let save = ((this.retailTotalPrice - this.totalPrice) /this.retailTotalPrice) * 100
               return Math.floor(save)
            },
            productsObject: function() {
               let productsObject = {};
               for (const product of this.visibleProducts) {
                  productsObject[product.id] = product
               }
               return productsObject
            },
			visibleProducts() {
				return this.products
					.filter(p => !p.isSpecialPackSubProduct)
                                        .filter(p => p.quantity>=1)
			},
			sortedCountries() {
				const c = Object.entries(this.countries).filter(([code]) => code != 'US')
				c.sort(([c1,n1],[c2,n2]) => {
					if (n1 > n2) {
						return 1
					} else if (n1 == n2) {
						return 0
					} else {
						return -1
					}
				})
				return ['US'].concat(c.map(([code]) => code))
			},
			country: function () {
				return this.countries[this.countryCode] || 'No country selected';
			},
			productData: function () {
				return JSON.parse(this.productDataJson)
			},
                        suggestedBlurbs: function () {
                                return JSON.parse(this.suggestedProductsBlurbJson)
                        },
			productsLink: function () {
					return "/products"
			},
			styles: function () {
				if (this.isOpen) {
					return 'right: 0;';
				} else {
					return 'right: -120%;';
				}
			},
			bvModalStyles: function () {
				if (this.bvModalIsOpen) {
					return 'display: none;';
				} else {
					return 'display: block;';
				}
			},
			currencySymbolLeft: function () {
				if (!euHempCountries[this.countryCode] && !currencySymbols.left[this.countryCode] && !currencySymbols.right[this.countryCode]) {
					return currencySymbols.left.US
				} else {
					return currencySymbols.left[this.countryCode]
				}
			},
         minusCurrencySymbolLeft: function () {
            if (!euHempCountries[this.countryCode] && !currencySymbols.left[this.countryCode] && !currencySymbols.right[this.countryCode]) {
               return "-" + currencySymbols.left.US
            } else {
               return "-" + currencySymbols.left[this.countryCode]
            }
         },
			currencySymbolRight: function () {
				if (euHempCountries[this.countryCode] && this.countryCode != 'GB') {
					return currencySymbols.right.EU
				} else {
					return currencySymbols.right[this.countryCode]
				} 
			},
			productCount: function() {
				return this.products
					.filter(({free}) => !free)
					.filter(({isSpecialPackSubProduct: c}) => !c)
					.reduce((a, {quantity}) => a + Number(quantity), 0)
			},
			productFreeCount: function() {
				return this.products
					.filter(({isSpecialPackSubProduct: c}) => !c)
					.filter(({free}) => free)
					.reduce((a, {quantity}) => a + Number(quantity), 0)
			},
            autoship: function() {
               try {
                  if (this.productsObject[this.primaryProduct].autoship) {
                     return true;
                  } else {
                     return false;
                  }
               } catch {

               }
            }
				// totalPrice: function () {
				//     return this.products.reduce((sum, i) => sum + i.quantity * i.price, 0)
				// },
				// totalBV: function () {
				//     return this.products.reduce((sum, i) => sum + i.quantity * i.bv, 0)
				// }
		},
		mounted: async function () {
			await this.getProducts()
//			this.updateShoppingCartCount()
			var openCartBtn = document.getElementById('openCart')
				,openCartBtnMobile = document.getElementById('openCartMobile');

			let vm = this;


			openCartBtn.addEventListener("click", function () {
				vm.isOpen = true;
				vm.getProducts();
			});

			 openCartBtnMobile.addEventListener("click", function () {
			 	vm.isOpen = true;
			 	vm.getProducts();
			 });
                        console.log("in created",this.openCartInitially)
                        if (this.openCartInitially && !this.isOpen) {
                           document.getElementById("openCart").click()
                           console.log("cart should be opening")
                        }
		}
    }

</script>

<style>
	.active {
		color: red;
		right: 0;
	}
	.flex-column {
		display: flex;
		flex-direction: column;
	}
	.space-between {
		justify-content: space-between;
	}
	.parent-height {
		max-height: 100%;
	}
	.fill {
		flex: 1;
	}
</style>
